export const TRIAL_ENDED_ADMIN = 'messages/trial_ended_admin';
export const TRIAL_ENDED = 'messages/trial_ended';
export const SUBSCRIPTION_EXPIRED_ADMIN = 'messages/subscription_expired_admin';
export const SUBSCRIPTION_EXPIRED = 'messages/subscription_expired';
export const INCORRECT_TIMEZONE = 'messages/incorrect_timezone';
export const APP_OUT_OF_DATE = 'messages/app_out_of_date';
export const UNSUPPORTED_BROWSER = 'messages/unsupported_browser';
export const INSTALL_MEMORY_REMINDER = 'messages/install_memory_reminder';
export const HAS_SNOOZED_INSTALL_PROMPT = 'has_snoozed_install_prompt';
export const HAS_SNOOZED_INSTALL_PROMPT_COUNT = 'has_snoozed_install_prompt_count';
export const CUSTOM_ASSETS_REVISION = 'messages/custom_assets_revision';
export const REQUESTED_REVISION_NOT_FOUND = 'messages/requested_rev_not_found';
export const NEW_REVISION_AVAILABLE = 'messages/new_revision_available';
export const EMULATING_PERMISSIONS = 'messages/emulating_permissions';
export const EMULATING_FEATURES = 'messages/emulating_features';
export const EMULATING_DEFAULT_MEMORY_SETTINGS = 'messages/emulating_default_memory_settings';
export const HAS_TASKS_ADD_ON_TRIAL = 'messages/HAS_TASKS_ADD_ON_TRIAL';
export const TIC_SERVICE_OFFLINE = 'messages/tic_service_offline';

export type Message =
  | typeof TRIAL_ENDED_ADMIN
  | typeof TRIAL_ENDED
  | typeof SUBSCRIPTION_EXPIRED_ADMIN
  | typeof SUBSCRIPTION_EXPIRED
  | typeof INCORRECT_TIMEZONE
  | typeof APP_OUT_OF_DATE
  | typeof UNSUPPORTED_BROWSER
  | typeof INSTALL_MEMORY_REMINDER
  | typeof CUSTOM_ASSETS_REVISION
  | typeof REQUESTED_REVISION_NOT_FOUND
  | typeof NEW_REVISION_AVAILABLE
  | typeof EMULATING_PERMISSIONS
  | typeof EMULATING_FEATURES
  | typeof EMULATING_DEFAULT_MEMORY_SETTINGS
  | typeof HAS_TASKS_ADD_ON_TRIAL
  | typeof TIC_SERVICE_OFFLINE;
